<template>
  <div class="brump-components" :class="{ border: border }">
    <div class="brump-title">
      <span class="brump-item" v-for="item in list" :key="item">
        {{ item }}
      </span>
    </div>
    <div class="brump-back" @click="handleGoBack" v-if="hasBack">
      <img src="@/assets/images/comp/backtop.png" alt="" /> 返回上级
    </div>
  </div>
</template>
<script>
import { routes as constantRouterMap } from "@/router/index.js";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    border: {
      type: Boolean,
      default: true,
    },
    hasBack: {
      type: Boolean,
      default: true,
    },
  },
  name: "BrumpComponent",
  computed: {
    _title() {
      return this.title;
    },
  },
  watch: {
    _title: {
      handler(newVal) {
        if (!newVal) return;
        this.list.pop();
        this.list.push(newVal);
      },
    },
  },
  data() {
    return {
      routeMap: {},
      list: [],
    };
  },
  created() {
    const res = this.generateBreadcrumbMap(constantRouterMap);
    this.routeMap = res;
    this.list = this.routeMap[this.$route.name];
  },
  mounted() {},
  methods: {
    handleGoBack() {
      this.$router.go(-1);
    },
    /**
     * 从路由数据中提取面包屑映射
     * @param {Array} routes - 路由配置数组
     * @return {Object} - 路由名称到面包屑数组的映射
     */
    generateBreadcrumbMap(routes) {
      // 结果映射对象
      const breadcrumbMap = {};

      /**
       * 递归处理路由及其子路由
       * @param {Array} routes - 当前处理的路由数组
       * @param {Array} parentPath - 父路由的面包屑路径
       * @param {String} parentRoutePath - 父路由的实际路径
       */
      function processRoutes(routes, parentPath = [], parentRoutePath = "") {
        if (!Array.isArray(routes)) return;

        routes.forEach((route) => {
          // 获取当前路由的标题
          const title = route.meta && route.meta.title ? route.meta.title : "";

          // 构建当前路由的完整路径
          const fullPath = parentRoutePath
            ? route.path.startsWith("/")
              ? route.path
              : `${parentRoutePath}/${route.path}`
            : route.path;

          // 构建当前路由的面包屑路径
          const currentPath = [...parentPath];
          if (title) {
            currentPath.push(title);
          }

          // 如果路由有名称，则添加到映射中
          if (route.name) {
            breadcrumbMap[route.name] = [...currentPath];
          }

          // 递归处理子路由
          if (route.children && route.children.length > 0) {
            processRoutes(route.children, currentPath, fullPath);
          }
        });
      }
      // 开始处理路由
      processRoutes(routes);
      return breadcrumbMap;
    },
  },
};
</script>
<style lang="less" scoped>
.brump-components {
  width: 100%;
  flex-shrink: 0;
  height: 48px;
  margin: 0 auto;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;

  .brump-title {
    display: flex;
    align-items: center;
    color: #999;
    font-size: 12px;
    font-weight: 400;
    .line1 {
      width: 4px;
      height: 20px;
      margin-right: 8px;
      background: #3967f2;
    }
    & > span:not(:last-child) {
      &::after {
        content: "/";
        margin: 0 8px;
      }
    }
  }
  .brump-back {
    position: relative;
    top: 1px;
    width: 84px;
    height: 26px;
    font-size: 12px;
    text-align: center;
    background: #fff;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    cursor: pointer;
    gap: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      position: relative;
      top: -1px;
    }
  }
}
.border {
  border-bottom: 1px solid #ededed;
}
</style>
